import { Injectable } from '@angular/core';
import {DocuSignDialogComponent} from "../shared/docu-sign-dialog/docu-sign-dialog.component";
import {MatDialog} from "@angular/material/dialog";

@Injectable({
  providedIn: 'root'
})
export class DocuSignService {

  constructor(private dialog: MatDialog) { }

  openDocuSignDialog = (url: string) => {
    const dialog = this.dialog.open(DocuSignDialogComponent, {
      width: '666px',
      height: '100vh',
      // position: { right: '0' },
      // backdropClass: 'bg-transparent',
      data: url,
    });
    dialog.afterClosed().subscribe(value => {
      if (value) {
        // this.fetshMission()
      }
    })
  };
}
